const translations = {
  en: ['Contents', 'Our purpose', 'Thoughtful products', 'Privacy first', 'Back to Plannely'],
  ru: ['Содержание', 'Наша цель', 'Продуманные продукты', 'Приватность в основе', 'Вернуться к Plannely'],
  zh: ['目录', '我们的目标', '用心打造产品', '隐私优先', '返回 Plannely'],
  es: ['Contenido', 'Nuestro propósito', 'Productos bien pensados', 'La privacidad primero', 'Volver a Plannely'],
  de: ['Inhalt', 'Unser Ziel', 'Durchdachte Produkte', 'Privatsphäre zuerst', 'Zurück zu Plannely'],
  fr: ['Sommaire', 'Notre objectif', 'Des produits réfléchis', 'La confidentialité avant tout', 'Retour à Plannely'],
  ja: ['目次', '私たちの目標', '考え抜かれた製品', 'プライバシーを第一に', 'Plannely に戻る'],
  hi: ['विषय सूची', 'हमारा उद्देश्य', 'सोच-समझकर बनाए गए उत्पाद', 'निजता सबसे पहले', 'Plannely पर वापस जाएँ'],
  pt: ['Conteúdo', 'Nosso propósito', 'Produtos bem pensados', 'Privacidade em primeiro lugar', 'Voltar ao Plannely'],
  ko: ['목차', '우리의 목표', '세심하게 만든 제품', '개인정보 보호 우선', 'Plannely로 돌아가기'],
  it: ['Indice', 'Il nostro obiettivo', 'Prodotti pensati con cura', 'La privacy prima di tutto', 'Torna a Plannely'],
  kk: ['Мазмұны', 'Біздің мақсатымыз', 'Ойластырылған өнімдер', 'Құпиялылық — басты қағида', 'Plannely-ге оралу'],
};

export function legalCopy(language) {
  const [contents, purpose, products, privacy, back] = translations[language] || translations.en;
  return { contents, purpose, products, privacy, back };
}
